import { render, staticRenderFns } from "./MyCascader.vue?vue&type=template&id=51a8498c&scoped=true"
import script from "./MyCascader.vue?vue&type=script&lang=js"
export * from "./MyCascader.vue?vue&type=script&lang=js"
import style0 from "./MyCascader.vue?vue&type=style&index=0&id=51a8498c&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a8498c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51a8498c')) {
      api.createRecord('51a8498c', component.options)
    } else {
      api.reload('51a8498c', component.options)
    }
    module.hot.accept("./MyCascader.vue?vue&type=template&id=51a8498c&scoped=true", function () {
      api.rerender('51a8498c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MyCascader.vue"
export default component.exports